// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-padding {
  padding: 8px 19px;
}
.import-box-style {
  margin-left: 80px;
  margin-right: 70px;
  margin-top: 2%;
  padding-bottom: 0px !important;
}
.import-box-wrning-msg {
  color: red !important;
  font-style: italic;
  font-size: 11pt;
  font-weight: bold;
  padding-top: 2% !important;
}
.error-msg-5mb {
  color: red;
  margin-left: 10px;
}
.upload-fail-error-msg {
  color: red;
  margin-left: 10px;
  font-weight: bold;
}
.upload-fail-error-msg-504 {
  color: green;
  margin-left: 10px;
  font-weight: bold;
}
.left-grid-style {
  border-right: 1px solid lightgray;
  padding: 7px;
}
.radio-group-container {
  flex-direction: row;
  align-items: center;
  margin-top: 16px;
}
.w-190 {
  width: 190px;
}
`, "",{"version":3,"sources":["webpack://./src/views/import/Import.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd","sourcesContent":[".button-padding {\n  padding: 8px 19px;\n}\n.import-box-style {\n  margin-left: 80px;\n  margin-right: 70px;\n  margin-top: 2%;\n  padding-bottom: 0px !important;\n}\n.import-box-wrning-msg {\n  color: red !important;\n  font-style: italic;\n  font-size: 11pt;\n  font-weight: bold;\n  padding-top: 2% !important;\n}\n.error-msg-5mb {\n  color: red;\n  margin-left: 10px;\n}\n.upload-fail-error-msg {\n  color: red;\n  margin-left: 10px;\n  font-weight: bold;\n}\n.upload-fail-error-msg-504 {\n  color: green;\n  margin-left: 10px;\n  font-weight: bold;\n}\n.left-grid-style {\n  border-right: 1px solid lightgray;\n  padding: 7px;\n}\n.radio-group-container {\n  flex-direction: row;\n  align-items: center;\n  margin-top: 16px;\n}\n.w-190 {\n  width: 190px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
